import { useIntl } from '@leagueplatform/locales';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { useNavigate } from 'react-router-dom';
import {
  MasonryWSDriverConfig,
  getMasonryWSRootNode,
} from '@leagueplatform/masonry-api';
import { wsDriver } from '@leagueplatform/masonry';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { PRODUCT_AREA, usePageViewAnalytics } from '@leagueplatform/analytics';
import {
  ParagraphText,
  StackLayout,
  styled,
} from '@leagueplatform/genesis-core';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { HeroSection } from 'components/hero-section/hero-section.component';

const config: MasonryWSDriverConfig = {
  appId: 'scfhp_forms_request_homepage',
  apiParams: { stringValue: 'params', integerValue: 20 },
  screenName: 'scfhp-app',
  productArea: PRODUCT_AREA.SETTINGS,
};
const MasonryFormsPageRootNode = getMasonryWSRootNode(config);

const MasonryGrid = styled('div', {
  // Masonry wraps each renderer in nested divs; target the rendered list container.
  '& > div > div > div': {
    display: 'grid',
    gridTemplateColumns: '1fr',
  },
  '& :has(> h3)': {
    // Keep section headers spanning the full row.
    gridColumn: '1/-1',
  },
  '@mobile': {
    'h2, h3': {
      typography: '$headingFour',
    },
  },
});

export const FormsPage = () => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_FORMS' }));

  usePageViewAnalytics({
    product_area: PRODUCT_AREA.SETTINGS,
    screen_name: 'Forms page',
    details: 'user views the forms page',
  });

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
        },
      }}
    >
      <HeroSection
        title={formatMessage({ id: 'STR_FORMS_TITLE' })}
        goBack={() => {
          navigate(-1);
        }}
        height="154px"
      />

      <StackLayout
        orientation="vertical"
        spacing="$oneAndHalf"
        css={{
          paddingTop: '$one',
          maxWidth: '894px',
        }}
      >
        <ParagraphText>{formatMessage({ id: 'STR_FORMS_DESC' })}</ParagraphText>

        <MasonryGrid
          css={{
            width: '100%',
            paddingBottom: '$five',
          }}
        >
          <MasonryEngine
            driver={wsDriver}
            rootNode={MasonryFormsPageRootNode}
          />
        </MasonryGrid>
      </StackLayout>
    </MainPageContainer>
  );
};
